import React from 'react';

import {
  FilterAvailabilityContext,
  useFilterAvailability,
  useFilterAvailabilityState,
} from './FilterAvailabilityContext';
import {
  StagedFiltersContext,
  useStagedFilters,
  useStagedFiltersState,
} from './StagedFiltersContext';

/**
 * Composes both pending-filter contexts into a single provider:
 *
 * 1. StagedFiltersContext — toggled-but-not-applied filter selections
 * 2. FilterAvailabilityContext — disabled option states from lean query
 *
 * Consumers subscribe via useStagedFilters() or useFilterAvailability().
 * See docs/grid-provider-architecture.md "Staged Filters & Disabled Option
 * States" for the full design.
 */
const PendingFiltersProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const stagingValue = useStagedFiltersState();
  const availabilityValue = useFilterAvailabilityState({
    stagedFilters: stagingValue.stagedFilters,
    stagedFiltersAsUrlParams: stagingValue.stagedFiltersAsUrlParams,
  });

  return (
    <StagedFiltersContext.Provider value={stagingValue}>
      <FilterAvailabilityContext.Provider value={availabilityValue}>
        {children}
      </FilterAvailabilityContext.Provider>
    </StagedFiltersContext.Provider>
  );
};

export { PendingFiltersProvider, useStagedFilters, useFilterAvailability };
